import { memo } from "react";

const DeviceGraphStatus = memo(({ isRefreshing, isExpanded }) => {
    if (!isRefreshing || !isExpanded) {
        return null;
    }

    return (
        <div className="tw-absolute tw-bottom-4 tw-left-0 tw-right-0 tw-flex tw-justify-center">
            <div className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-text-gray-500 tw-italic tw-bg-white tw-px-3 tw-py-1 tw-rounded tw-shadow">
                <div className="tw-flex tw-gap-1">
                    <div
                        className="tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-gray-500 tw-animate-bounce"
                        style={{ animationDelay: "0ms" }}
                    ></div>
                    <div
                        className="tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-gray-500 tw-animate-bounce"
                        style={{ animationDelay: "150ms" }}
                    ></div>
                    <div
                        className="tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-gray-500 tw-animate-bounce"
                        style={{ animationDelay: "300ms" }}
                    ></div>
                </div>
                <span>fetching fresh data...</span>
            </div>
        </div>
    );
});

DeviceGraphStatus.displayName = "DeviceGraphStatus";

export default DeviceGraphStatus;
